import { getApiUrl, AXIOS_AUTHED } from './shared';
import { serializeAsQueryString } from '../../utils/utils';

const EMBLEM_CHARGES_BASE_URL = `${getApiUrl()}/emblem-charges`;

const DEFAULT_SEARCH = {
  customerIds: null
};

const search = (criteria = DEFAULT_SEARCH) => {
  const queryString = serializeAsQueryString(criteria, true);
  return AXIOS_AUTHED.get(`${EMBLEM_CHARGES_BASE_URL}?${queryString}`);
};

export { search };
